import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

const Tab = ({ id, label, onClick, isSelected = false }) => {
  const labelHandler = () => onClick(id);

  return (
    <Wrapper onClick={labelHandler} isSelected={isSelected} data-selected={isSelected}>
      <p>{label}</p>
    </Wrapper>
  );
};

Tab.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool
};

export default Tab;
